import React from "react";
import { Navbar } from "@nef/core";
import styled from "styled-components";

const StyledAppNavBar = styled(Navbar)`
  &.app-navbar {
    position: unset;
    font-family: sans-serif;
  }
`;

export default StyledAppNavBar;
